module.exports = __webpack_public_path__ + "media/23.5e51d1bf.mp3";